export enum ERoutes {
  Root = "/",
  Accounts = "accounts",
  ChooseMethod = "choose-method",
  BankTransfer = "bank-transfer",
  MethodDetail = "method-detail",
  PaymentPlacement = "payment-placement",
  Completion = "completion",
  Summary = "summary",
  // TODO: Replace this with the real routes
  CompletionSuccess = "completion/success",
  CompletionFailed = "completion/failed",
  CompletionPending = "completion/pending",
  ErrorPage = "error-page",
  LoadingPage = "loading-page",
  Verification = "verification",
}

export enum ECashierFlows {
  Deposit = "deposit",
  Withdraw = "withdraw",
  History = "history",
  Transfer = "transfer",
}

export enum EPaymentMethodId {
  CreditCard = "00000000-0000-0000-0000-000000000001",
  BankTransfer = "00000000-0000-0000-0000-000000000007",
  PayPal = "00000000-0000-0000-0000-000000000006",
  Crypto = "00000000-0000-0000-0000-000000000002",
  UnionPayOption1 = "00000000-0000-0000-0000-000000000003",
  UnionPayOption2 = "00000000-0000-0000-0000-000000000004",
  UnionPayOption3 = "00000000-0000-0000-0000-000000000005",
}

export enum EPaymentMethodGroupId {
  UnionPay = "a0000000-0000-0000-0000-000000000001",
  BankWire = "a0000000-0000-0000-0000-000000000002",
}

export enum EPaymentMethodTime {
  Instant = "Instant",
  UpTo3Days = "Up to 3 days",
  UpTo5Days = "Up to 5 days",
  UpTo7Days = "Up to 7 days",
  UpTo14Days = "Up to 14 days",
  UpTo30Days = "Up to 30 days",
  TwoToFiveDays = "2 - 5 days",
}

export enum EFormValidationType {
  CreditCard = "creditCard",
  ExpiryDate = "expiryDate",
  CVV = "CVV",
}

export enum EFormType {
  Inline = "inline",
  FullPage = "fullPage",
}

export enum EFormIds {
  CreditCard = "creditCardForm",
  PayPal = "paypalForm",
  Amount = "amountForm",
  UnionPayOption1 = "unionPayOption1Form",
  UnionPayOption2 = "unionPayOption2Form",
  UnionPayOption3 = "unionPayOption3Form",
}

export enum EPaymentStatus {
  Successful = "successful",
  Pending = "pending",
  Failed = "failed",
  Rejected = "rejected",
}

export enum EAccountType {
  Standard = "Standard",
  Razor = "Razor",
}

export enum ECurrency {
  Dollar = "USD",
  Euro = "EUR",
  AustralianDollar = "AUD",
  PoundSterling = "GBP",
  ChineseYuan = "CNY",
}

export enum ECurrencySymbol {
  Dollar = "$",
  Euro = "€",
  AustralianDollar = "A$",
  PoundSterling = "£",
  ChineseYuan = "¥",
}

export enum EIcon {
  CreditCard = "methods/credit-card",
  BankTransfer = "methods/bank-transfer",
  ApplePay = "methods/applepay",
  PayPal = "methods/paypal",
  Crypto = "methods/crypto",
  UnionPay = "methods/unionpay",
  ArrowDown = "arrow-down",
  ArrowUp = "arrow-up",
  ScrollToTop = "scroll-to-top",
  PepperLogo = "pepper-logo",
  FlagAUD = "flags/aud-flag",
  FlagEUR = "flags/eur-flag",
  FlagGBP = "flags/gbp-flag",
  FlagCAD = "flags/cad-flag",
  FlagCHF = "flags/chf-flag",
  FlagJPY = "flags/jpy-flag",
  FlagNZD = "flags/nzd-flag",
  FlagSGD = "flags/sgd-flag",
  FlagCZK = "flags/czk-flag",
  FlagMXN = "flags/mxn-flag",
  FlagNOK = "flags/nok-flag",
  FlagPLN = "flags/pln-flag",
  FlagTRY = "flags/try-flag",
  FlagUSD = "flags/usd-flag",
  FlagCNY = "flags/cny-flag",
  FlagHKD = "flags/hkd-flag",
  FlagUGA = "flags/uga-flag",
  FlagTZA = "flags/tza-flag",
  FlagNGA = "flags/nga-flag",
  FlagDE = "flags/de-flag",
  Close = "close",
  Information = "information",
  InformationBlue = "information-blue",
  InformationGray = "information-gray",
  Download = "download",
  ErrorPageIcon = "error-page-icon",
  ErrorRedCrossIcon = "error-red-cross-icon",
  Announcement = "announcement",
  Copy = "copy",
  ThankYouFailed = "thank_you_failed",
  GeneralError = "general-error-light-blue",
  NoResults = "no-results-light-blue",
  EmptyStateError = "error-empty-state-light-blue",
  EmptyResultError = "error-empty-result-light",
  Plus = "plus",
  ArrowLeftNarrow = "arrow-left-narrow",
}
